import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/service/auth/auth.service';
import { LandingPageService } from '../../service/landing-page/landing-page.service';
import { LandingPage } from 'src/app/models/firebase/landing-page';
import { SpinnerService } from 'src/app/service/spinner/spinner.service';
import { GetLanguageService } from 'src/app/service/get-language/get-language.service';
import { IMAGES_RESOLUTIONS } from 'src/app/utils/image-config';
import { LandingPageBanner } from 'src/app/models/firebase/landingPageBanner';
import { filter, Subscription } from 'rxjs';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit{

    landingPageData: LandingPage = new LandingPage();
    landingPageBanner: LandingPageBanner = new LandingPageBanner();
    IMAGES_RESOLUTIONS = IMAGES_RESOLUTIONS;
    isLoaded = false;
    languageSubscription: Subscription;
    constructor(
        private authService: AuthService,
        private LandingPageService: LandingPageService,
        public spinnerService: SpinnerService,
        public getLanguageService: GetLanguageService,
    ) {}

    async ngOnInit(): Promise<void> {
        this.isLoaded = false;
        this.languageSubscription = this.getLanguageService.languageChanged
        .pipe(filter(lang => !!lang))
        .subscribe(lang => {
            this.loadData(lang);
        });
        this.isLoaded = true;
    }

    async loadData(lang: string){
        this.landingPageBanner = await this.LandingPageService.getLandingPageBannerDataByLanguage(this.authService.projectId, lang);
    }
    async chargeLandingPage(){
        this.landingPageData = await this.LandingPageService.getLandingPageData(this.authService.projectId);
    }
}
